/** ***********
*
* <zone.ts v1.0>
*
* Copyright (c) 2023 AIRBUS OPERATIONS
*
* Contributors:
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*
* All rights reserved.
**************/

import { FamilyRight } from 'src/app/models/family';
import { Scope } from './profile';
export interface MapZone {
    objectid: number;
    objectid1: number;
    parentname: string;
    zonelevel: string;
    zonename: string;
    zonestatus?: string;
    families?: Array<string>;
}

export interface Zone {
    site: string;
    siteId: string;
    company: string;
    owner: string;
    zoneStatus: string;
    coordinates: Polygon;
    parent: string;
    name: string;
    id: string;
    objectId: string;
    zoneContact: string;
    zoneLevel: string;
    type: string;
    zoneType: Array<ZoneType>;
    associatedFamilies: {
        [scope in Scope]: Array<ZoneAssociatedFamilies>;
    };
    associatedFamiliesMapped?: Array<FamilyRight>; // Front only, needed for filter purpose
    iataCode?: string;
    workCenter?: string;
}

export interface ZoneUpdate {
    siteId: string;
    zoneContact: string;
    owner?: string;
    iataCode?: string;
    associatedFamilies: {
        [scope: string]: Array<ZoneAssociatedFamilies>;
    };
    workCenter?: string;
}

export enum ZoneType {
    arrival = 'arrival',
    departure = 'departure',
    aircraft = 'aircraft',
    busy = 'busy',
    maintenance = 'maintenance',
    caTracking= 'caTracking',
}

export interface ZoneAssociatedFamilies {
    familyId: string;
    type: ZoneType[];
    family?: FamilyRight;
}

export interface Polygon {
    coordinates: Array<Array<Array<number>>>;
    type: 'Polygon';
}

export enum ZoneStatus {
    occupied = 'occupied',
    booked = 'booked',
    available = 'available',
}

export interface KpiZone {
    zone_id: string;
    zone_level: string;
    zone_name: string;
    parent_zone_id: string;
}

export interface KpiZoneByLevel {
    id: string;
    level: string;
    fullName: string;
    name: string;
    extendedZone: {
      zone1: string;
      zone2?: string;
      zone3?: string;
    };
}
